export default "__VITE_ASSET__BGC3ndS5__"